import { useState, useEffect } from 'react'
import { SectionHeader } from './ui/StyledComponents'
import GreenbookProgressFields from './GreenbookProgressFields'
import supabase from '../supabaseClient'
import { useAuth } from '../context/AuthContext'
import { updateCurrentTeacherActivity } from '../utils/teacherActivity'
import { Grid } from '@mui/material'
import { forwardRef, useImperativeHandle } from 'react'
const StudentGreenbookProgress = forwardRef(function StudentGreenbookProgress({ studentId, classId, date }, ref) {
  const [startingPage, setStartingPage] = useState(null)
  const [endingPage, setEndingPage] = useState(null)
  const [assignmentCompleted, setAssignmentCompleted] = useState(false)
  const [notes, setNotes] = useState('')
  const { user, userRole } = useAuth()

  useEffect(() => {
    const fetchGreenbookProgress = async () => {
      const { data, error } = await supabase
        .from('student_greenbook_progress')
        .select('*')
        .eq('student_id', studentId)
        .eq('class_id', classId)
        .eq('date', date.format('YYYY-MM-DD'))
        .maybeSingle()

      if (error || !data) {
        setStartingPage('')
        setEndingPage('')
        setAssignmentCompleted(false)
        setNotes('')
      } else {
        setStartingPage(data.starting_page)
        setEndingPage(data.ending_page)
        setAssignmentCompleted(data.assignment_completed || false)
        setNotes(data.notes || '')
      }
    }

    if (studentId && classId) {
      fetchGreenbookProgress()
    }
  }, [studentId, classId, date])

  const saveGreenbookProgress = async () => {
    const formattedDate = date.format('YYYY-MM-DD')
    
    const { error } = await supabase
      .from('student_greenbook_progress')
      .upsert(
        [
          {
            student_id: studentId,
            class_id: classId,
            date: formattedDate,
            starting_page: startingPage || null,
            ending_page: endingPage || null,
            assignment_completed: assignmentCompleted,
            notes: notes || null,
          },
        ],
        { onConflict: ['student_id', 'date', 'class_id'] }
      )

    // Update teacher activity tracking if save was successful
    if (!error) {
      await updateCurrentTeacherActivity(user, userRole)
    }

    return { error }
  }

  useImperativeHandle(ref, () => ({
    saveGreenbookProgress,
  }))

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SectionHeader variant="h6">Greenbook Progress</SectionHeader>
        <GreenbookProgressFields
          startPage={startingPage}
          endPage={endingPage}
          assignmentCompleted={assignmentCompleted}
          notes={notes}
          onStartPageChange={(e) => setStartingPage(e.target.value)}
          onEndPageChange={(e) => setEndingPage(e.target.value)}
          onAssignmentCompletedChange={(e) =>
            setAssignmentCompleted(e.target.checked)
          }
          onNotesChange={(e) => setNotes(e.target.value)}
        />
      </Grid>
    </Grid>
  )
})

export default StudentGreenbookProgress 